import { Box, Text } from '@user-portal/wikr-components';
import styled from 'styled-components';

import { color } from 'theme/selectors';

export const LogInMobileWrapper = styled(Box)`
    display: block;
    width: 100%;
`;

export const AccessCodeBtn = styled.button`
    background-color: ${color('surface-default')};
    border-radius: ${({ theme }) => `${theme['border-radius-medium']}px`};
    padding: 16px;
    display: block;
    width: 100%;
    margin-bottom: 24px;
`;

export const AccessCode = styled(Text)`
    letter-spacing: 2px;
    span:nth-child(3) {
        margin-right: 4px;
    }
`;
